import { useLocation } from "react-router";
import {
  Accordion,
  AccordionSummary,
  Typography,
  AccordionActions,
  Box,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import IndustriesMenu from "@/components/Header/IndustriesMenu";
import Products from "@/components/Header/SolutionsMenu/Products";
import Platform from "@/components/Header/SolutionsMenu/Platform";
import TechnologyMenu from "@/components/Header/TechnologyMenu";
import { ROUTES } from "@/utils/navigation";
import ResourcesMenu from "@/components/Header/ResourcesMenu";
import { accordionStyles, accordionSummaryStyles } from "../styles";

interface IProps {
  summary: string;
  path: string;
  activeSubMenu: string | null;
  closeNavMenu: () => void;
  toggleAccordionMenu: (path: string) => void;
}

const Submenu: React.FC<IProps> = ({
  summary,
  path,
  closeNavMenu,
  toggleAccordionMenu,
  activeSubMenu,
}) => {
  const { pathname } = useLocation();
  const mainRoute = location.pathname.split("/")[1];
  const isActiveLink =
    pathname === path ||
    (mainRoute === "industries" && `/${mainRoute}` === path);

  return (
    <Accordion
      sx={accordionStyles}
      expanded={activeSubMenu === path}
      onChange={() => toggleAccordionMenu(path)}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1-content"
        id="panel1-header"
        sx={accordionSummaryStyles}
      >
        <Typography
          variant="subtitle1"
          color={isActiveLink ? "text.accent" : "text.primary"}
          component="span"
        >
          {summary}
        </Typography>
      </AccordionSummary>

      <AccordionActions sx={{ padding: 0, width: "100%" }}>
        {path === ROUTES.solutions && (
          <Box
            width="100%"
            display="flex"
            flexDirection="column"
            gap={4}
            py={1.5}
          >
            <Box>
              <Platform closeDropDown={closeNavMenu} />
            </Box>
            <Box>
              <Products closeDropDown={closeNavMenu} />
            </Box>
          </Box>
        )}

        {path === ROUTES.whyTrackmate && (
          <Box width="100%">
            <TechnologyMenu closeDropDown={closeNavMenu} />
          </Box>
        )}

        {path === ROUTES.industries && (
          <Box width="100%">
            <IndustriesMenu closeDropDown={closeNavMenu} />
          </Box>
        )}

        {path === ROUTES.resources && (
          <Box width="100%">
            <ResourcesMenu closeDropDown={closeNavMenu} />
          </Box>
        )}
      </AccordionActions>
    </Accordion>
  );
};

export default Submenu;
